<template>
  <AppTitle>
    <template #title>ตั้งค่าระบบ</template>
    <template #subtitle>Wanon Niwat Hospital [5S SYSTEM WNH]</template>
    <template #breadcrumb>หน้าหลัก</template>
  </AppTitle>

  <div class="row">
    <div class="col-md-8 col-lg-6">
      <div class="tile">
        <h3 class="tile-title">การบันทึกข้อมูล</h3>
        <div class="tile-body">
          <div v-if="loading" class="text-center py-4 text-muted">
            กำลังโหลด...
          </div>
          <div v-else class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="showRecordDateTime"
              v-model="showRecordDateTime"
              :disabled="saving"
              @change="saveSetting"
            />
            <label class="form-check-label" for="showRecordDateTime">
              {{ setting?.label || "แสดงวันที่/เวลาในฟอร์มบันทึก" }}
            </label>
            <p class="text-muted small mb-0 mt-2">
              {{
                setting?.description ||
                "เปิดให้ผู้บันทึกแก้ไขวันที่และเวลาในหน้าบันทึกข้อมูลได้"
              }}
            </p>
            <p class="text-muted small mt-1 mb-0">
              มีผลกับหน้าบันทึก: ถังดับเพลิง, ตู้ยา, ห้องอุณหภูมิ, ห้องน้ำ,
              ค่าแรงดันก๊าซ, Defibrillator
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AppTitle from "@/layouts/AppTitle.vue";
import axiosInstance from "@/utils/axiosInstance";
import { showErrorAlert, showSuccessAlert } from "@/utils/sweetalert2-utils";

const SETTING_KEY = "show_record_datetime";

const loading = ref(true);
const saving = ref(false);
const setting = ref(null);
const showRecordDateTime = ref(false);

const fetchSetting = async () => {
  loading.value = true;
  try {
    const { data } = await axiosInstance.get(`/settings/${SETTING_KEY}`);
    setting.value = data;
    showRecordDateTime.value = Boolean(data.bool_value);
  } catch (error) {
    console.error(error);
    showErrorAlert("ไม่สามารถโหลดการตั้งค่าได้");
  } finally {
    loading.value = false;
  }
};

const saveSetting = async () => {
  saving.value = true;
  try {
    const { data } = await axiosInstance.put(`/settings/${SETTING_KEY}`, {
      value: showRecordDateTime.value,
    });
    setting.value = data.data;
    showSuccessAlert(
      showRecordDateTime.value
        ? "เปิดการแก้ไขวันที่/เวลาแล้ว"
        : "ปิดการแก้ไขวันที่/เวลาแล้ว"
    );
  } catch (error) {
    console.error(error);
    showRecordDateTime.value = !showRecordDateTime.value;
    showErrorAlert("ไม่สามารถบันทึกการตั้งค่าได้");
  } finally {
    saving.value = false;
  }
};

onMounted(fetchSetting);
</script>
